import { render } from "./BaseSnackbar.vue?vue&type=template&id=57de5ab2&scoped=true&ts=true"
import script from "./BaseSnackbar.vue?vue&type=script&lang=ts"
export * from "./BaseSnackbar.vue?vue&type=script&lang=ts"

import "./BaseSnackbar.vue?vue&type=style&index=0&id=57de5ab2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57de5ab2"]])

export default __exports__